import React from 'react';
import ObtUploadPartnerContacts from './ObtUploadPartnerContacts';

const ObtUpdateTab: React.FC = () => {
    return (
        <div style={{ padding: '16px 0' }}>
            <ObtUploadPartnerContacts />
        </div>
    );
};

export default ObtUpdateTab;
